(function () {
  var PV = window.PV = window.PV || {};
  var FREE = 10000; /* gratis verzending vanaf EUR 100, in centen */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var fmt = function (c) { return '€' + (c / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML.replace(/'/g, '&#39;'); };

  PV.setCount = function (n) { $$('.site-header__cart-count').forEach(function (el) { el.textContent = n; }); };

  PV.updateShipBars = function (total) {
    var left = FREE - total;
    var pct = Math.max(0, Math.min(100, Math.round(total / FREE * 100)));
    $$('[data-ship-bar]').forEach(function (bar) {
      var t = $('[data-ship-text]', bar), f = $('[data-ship-fill]', bar);
      if (t) t.textContent = left > 0 ? 'Nog ' + fmt(left) + ' tot gratis verzending' : 'Je bestelling wordt gratis verzonden';
      if (f) f.style.width = pct + '%';
      bar.classList.toggle('is-done', left <= 0);
    });
  };

  /* ===== Winkelwagen zijpaneel ===== */
  var drawer = $('#CartDrawer'), overlay = $('[data-cd-overlay]');
  if (drawer && overlay) {
    var bodyEl = $('[data-cd-body]', drawer), footEl = $('[data-cd-foot]', drawer), shipEl = $('[data-cd-ship]', drawer), countEl = $('[data-cd-count]', drawer);
    var lastFocus = null;

    var getCart = function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); };

    var shipMarkup = function (total) {
      var left = FREE - total, pct = Math.max(0, Math.min(100, Math.round(total / FREE * 100)));
      var t = left > 0 ? 'Nog ' + fmt(left) + ' tot gratis verzending' : 'Je bestelling wordt gratis verzonden';
      return `<div class='ship-bar${left <= 0 ? ' is-done' : ''}' data-ship-bar><p class='ship-bar__text' data-ship-text>${t}</p><div class='ship-bar__track'><span class='ship-bar__fill' data-ship-fill style='width:${pct}%'></span></div></div>`;
    };

    var draw = function (cart) {
      PV.setCount(cart.item_count);
      countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
      if (!cart.items.length) {
        shipEl.innerHTML = '';
        bodyEl.innerHTML = `<div class='cd-empty'><p class='cd-empty__title'>Je winkelwagen is leeg</p><p class='cd-empty__sub'>Voeg padelballen toe om te beginnen.</p><a class='btn btn--lime' href='/collections/padelballen'>Bekijk assortiment</a></div>`;
        footEl.innerHTML = '';
        return;
      }
      shipEl.innerHTML = shipMarkup(cart.total_price);
      bodyEl.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? `<p class='cd-item__variant'>${esc(it.variant_title)}</p>` : '';
        return `<div class='cd-item' data-line='${i + 1}'>` +
          `<a class='cd-item__img' href='${it.url}'>${img ? `<img src='${img}' alt='${esc(it.product_title)}' loading='lazy'>` : ''}</a>` +
          `<div class='cd-item__info'><p class='cd-item__vendor'>${esc(it.vendor)}</p><a class='cd-item__title' href='${it.url}'>${esc(it.product_title)}</a>${variant}` +
          `<div class='cd-item__row'><div class='cd-qty'><button type='button' data-act='minus' aria-label='Minder'>–</button><span class='cd-qty__n'>${it.quantity}</span><button type='button' data-act='plus' aria-label='Meer'>+</button></div><span class='cd-item__price'>${fmt(it.final_line_price)}</span></div></div>` +
          `<button type='button' class='cd-item__remove' data-act='remove' aria-label='Verwijder'>×</button></div>`;
      }).join('');
      footEl.innerHTML = `<div class='cd-sum'><span>Subtotaal</span><span class='cd-sum__val'>${fmt(cart.total_price)}</span></div><p class='cd-note'>Btw inbegrepen. Verzendkosten worden bij het afrekenen berekend.</p><a class='btn btn--lime cd-checkout' href='/checkout'>Afrekenen</a><a class='cd-link' href='/cart'>Bekijk winkelwagen</a>`;
    };

    var showMsg = function (msg) {
      if (!msg) return;
      bodyEl.insertAdjacentHTML('afterbegin', `<p class='cd-msg'>${esc(msg)}</p>`);
      setTimeout(function () { var m = $('.cd-msg', bodyEl); if (m) m.remove(); }, 4500);
    };

    bodyEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-act]');
      if (!btn) return;
      var row = btn.closest('.cd-item');
      var line = parseInt(row.getAttribute('data-line'), 10);
      var q = parseInt($('.cd-qty__n', row).textContent, 10) || 1;
      var act = btn.getAttribute('data-act');
      var nq = act === 'plus' ? q + 1 : (act === 'minus' ? q - 1 : 0);
      row.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, nq) })
      }).then(function (r) { return r.json(); }).then(function (c) {
        if (c && c.items) { draw(c); return; }
        var msg = c && (c.description || c.message);
        return getCart().then(function (cc) { draw(cc); showMsg(msg); });
      }).catch(function () { row.classList.remove('is-busy'); });
    });

    var open = function (cart) {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cd-lock');
      if (cart && cart.items) { draw(cart); } else { getCart().then(draw); }
      setTimeout(function () { var c = $('[data-cd-close]', drawer); if (c) c.focus(); }, 60);
    };
    var close = function () {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cd-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    PV.openCart = open;
    PV.closeCart = close;
    overlay.addEventListener('click', close);
    $('[data-cd-close]', drawer).addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

    $$('.site-header__cart').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var p = location.pathname.replace(/\/$/, '');
        if (p.slice(-5) === '/cart') return;
        e.preventDefault();
        open();
      });
    });
  }

  /* ===== Sterren op productkaartjes ===== */
  var ratings = {};
  try { var rt = $('#pv-ratings'); if (rt) ratings = JSON.parse(rt.textContent || '{}'); } catch (err) { ratings = {}; }
  $$('.product-card').forEach(function (card) {
    var a = card.tagName === 'A' ? card : $('a[href*="/products/"]', card);
    var href = a ? (a.getAttribute('href') || '') : '';
    if (href.indexOf('/products/') < 0) return;
    var handle = href.split('/products/')[1].split(/[?#]/)[0];
    var d = ratings[handle];
    var name = $('.product-card__name', card);
    if (!d || !name || $('.rating', card)) return;
    name.insertAdjacentHTML('afterend', `<span class='rating'><span class='rating__stars' style='--pct:${d.r * 20}%'></span><span class='rating__text'>${Number(d.r).toFixed(1).replace('.', ',')} (${d.c})</span></span>`);
  });

  /* ===== Vaste knop op mobiel (productpagina) ===== */
  var sticky = $('#StickyAtc'), atcRow = $('#AtcRow'), mainBtn = $('#AddToCartBtn');
  if (sticky && atcRow && mainBtn) {
    var rowVisible = true;
    var priceEl = $('#ProductPrice'), stickyPrice = $('#StickyPrice');
    var updateSticky = function () {
      var hidden = window.getComputedStyle(atcRow).display === 'none';
      var show = !rowVisible && !hidden;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('has-sticky-atc', show);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { rowVisible = entries[0].isIntersecting; updateSticky(); }, { threshold: 0.1 }).observe(atcRow);
    }
    new MutationObserver(updateSticky).observe(atcRow, { attributes: true, attributeFilter: ['style'] });
    if (priceEl && stickyPrice) {
      var syncPrice = function () { var n = priceEl.firstChild; if (n && n.textContent.trim()) stickyPrice.textContent = n.textContent.trim(); };
      new MutationObserver(syncPrice).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
    $('#StickyAtcBtn').addEventListener('click', function () { mainBtn.click(); });
  }

  /* ===== Nieuwsbriefkaart ===== */
  var nl = $('#NlCard');
  if (nl) {
    var store = {
      get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    };
    var formWrap = $('[data-nl-form]', nl), doneWrap = $('[data-nl-done]', nl);
    var showNl = function () { nl.hidden = false; requestAnimationFrame(function () { nl.classList.add('is-in'); }); };
    var hideNl = function () { nl.classList.remove('is-in'); setTimeout(function () { nl.hidden = true; }, 300); };
    var posted = !!$('[data-nl-posted]', nl) || location.search.indexOf('customer_posted=true') > -1;
    if (posted) {
      formWrap.hidden = true; doneWrap.hidden = false;
      store.set('pv_nl_done', '1');
      showNl();
      try { history.replaceState(null, '', location.pathname); } catch (e) {}
    } else if ($('[data-nl-error]', nl)) {
      showNl();
    } else if (!store.get('pv_nl_done')) {
      var closedAt = parseInt(store.get('pv_nl_closed') || '0', 10);
      if (!closedAt || Date.now() - closedAt > 14 * 24 * 3600 * 1000) { setTimeout(showNl, 20000); }
    }
    $('[data-nl-close]', nl).addEventListener('click', function () { store.set('pv_nl_closed', String(Date.now())); hideNl(); });
  }
})();
